export default __webpack_public_path__ + "static/char-41-anr-323d0d161c89aa25c4713ffc03460f12.webp";